export default {
      id: "icon-publications-usage",
      viewBox: "0 0 19.97 26.536",
      url: __webpack_public_path__ + "icons.svg#icon-publications",
      toString: function () {
        return this.url;
      }
    }